import React from "react";
import { useNavigate } from "react-router-dom";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 overflow-hidden bg-zinc-950 text-white">
      <img
        src="/landing-hero.png"
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-35 pointer-events-none select-none"
        draggable={false}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/15 via-zinc-950/45 to-zinc-950" />
      <main className="relative z-10 flex min-h-full items-end justify-center p-5 pb-10">
        <section className="w-full max-w-md rounded-3xl border border-white/10 bg-zinc-950/95 p-6 shadow-2xl backdrop-blur">
          <div className="label-eyebrow text-[#007AFF]">PROXIMITY</div>
          <h1 className="mt-2 font-display text-4xl font-black tracking-tighter">Stay connected to your people.</h1>
          <p className="mt-3 text-sm leading-6 text-zinc-400">
            Share real-time location with trusted friends and family, create safe zones, and know when someone important is nearby.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3">
            <button
              data-testid="landing-signin-btn"
              onClick={() => navigate("/signin")}
              className="rounded-full border border-white/15 px-4 py-3 text-sm font-bold hover:bg-white/5"
            >
              Sign in
            </button>
            <button
              data-testid="landing-create-account-btn"
              onClick={() => navigate("/signup")}
              className="rounded-full bg-[#007AFF] px-4 py-3 text-sm font-bold text-white hover:bg-[#0066d6]"
            >
              Create account
            </button>
          </div>
          <p className="mt-4 text-center text-xs text-zinc-500">Your location is shared only with people you accept.</p>
        </section>
      </main>
    </div>
  );
}
